document.addEventListener("DOMContentLoaded", () => {
  let wishlist = JSON.parse(localStorage.getItem("truth-coffee__wishlist")) || [];
  const customerDataElement = document.getElementById("customer-data");
  const loadingMessage = document.getElementById("wishlist-loading");
  const cartBtns = document.querySelectorAll(`[id^="cart-wishlist"]`);
  const wishlistHandlesElement = document.getElementById("wishlist-handles");
  const wishlistHeaderElement = document.getElementById("wishlist-headers");
  const alertBanner = document.getElementById("alert-banner");
  const removeLinks = document.querySelectorAll(".js-remove-item");

  function enableOtherButtons() {
    cartBtns.forEach((btn) => {
      btn.disabled = false; // Enable buttons
      btn.classList.remove('disabled');
    });
  }

  if (!customerDataElement) {
    console.warn("Required script tags not found");
    return;
  }

  const customerData = JSON.parse(customerDataElement.textContent);

  function extractProductInfo(obj) {
    console.log(obj, 'obj')
    return Array.from({ length: obj.records }).map((_, i) => ({
      product_id: Number(obj.product_id[i]),
      product_handle: obj.product_handle[i],
      proimage: obj.product_img[i],
      protitle: obj.product_name[i],
      vname: obj.variant_name[i],
      proprice: obj.product_price[i],
      checked: true,
    }));
  }

  function loadZooomyData(customerId) {
    console.log(customerId, 'customerID')
    const ZooomyDataFun = (B, J, M) => {
      B.ajax({
        url: "https://zooomyapps.com/wishlist/ListWishlist.php",
        data: { shop: J, customerid: M },
        dataType: "jsonp",
        jsonp: "ZooomyGetDataPage",
        async: "true",
        success: (n) => {
          wishlist = extractProductInfo(n);
          updateWishlistStorage();
        },
        error: (t) => console.log(t, "t"),
      });
    };

    if (typeof window.jQuery === "undefined") {
      loadJQuery(() =>
        ZooomyDataFun(
          window.jQuery.noConflict(true),
          "truth-coffee-roasting-za.myshopify.com",
          customerId
        )
      );
    } else {
      ZooomyDataFun(
        window.jQuery,
        "truth-coffee-roasting-za.myshopify.com",
        customerId
      );
    }
  }

  if (!customerData) {
    handleNotLoggedIn(loadingMessage);
    localStorage.removeItem("truth-coffee__wishlist");
  } else {
    loadZooomyData(customerData.customer_id);
  }

  if (customerData && wishlist.length === 0) {
    emptyWishlist(loadingMessage);
    if (wishlistHeaderElement) {
      wishlistHeaderElement.style.display = "none";
    }
  }

  function emptyWishlist(loadingMessage) {
    if (loadingMessage) {
      loadingMessage.innerHTML = `
      <div class="x-flex x-flex-col logged-in-alert x-justify-center x-items-center">
        <div class="alert-text">
          <p>Your Wishlist is empty</p>
        </div>
        <div class="x-flex x-gap-4 alert-btns">
          <a href="/collections/all" class="btn btn-1">Shop Now</a>
        </div>
      </div>
    `;
    }
    if (wishlistHandlesElement) {
      wishlistHandlesElement.style.display = "none";
      wishlistHandlesElement.style.display = "none";
    }
    console.warn("Wishlist is empty");
  }

  function removeItem(productId) {
    wishlist = wishlist.filter((item) => item.product_id !== productId);
    const script = document.createElement("script");
    script.src = `https://zooomyapps.com/wishlist/RemoveFromWishlist.php?shop=truth-coffee-roasting-za.myshopify.com&productid=${productId}&customerid=${customerData.customer_id}&wishcount=${wishlist.length}`;
    document.head.appendChild(script);

    if (wishlist.length === 0) {
      if (loadingMessage) {
        loadingMessage.style.display = "block";
        emptyWishlist(loadingMessage);
      }
    }

    updateWishlistStorage();
  }

  function addItem(product) {
    wishlist.push(product);
    updateWishlistStorage();

    const scriptTag = document.createElement("script");
    scriptTag.src = `https://zooomyapps.com/wishlist/wishlist-check1.php?shop=truth-coffee-roasting-za.myshopify.com&productid=${product.product_id}&product_handle=${product.product_handle}&customerid=${customerData.customer_id || "guest"}&checked=true&wishcount=${wishlist.length}&variantname=${new Date()}&totalv=2`;
    document.head.appendChild(scriptTag);
  }

  function updateWishlistStorage() {
    localStorage.setItem("truth-coffee__wishlist", JSON.stringify(wishlist));
    fetchProductData();
  }

  async function updateCartDisplay() {
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await cartResponse.json();
      renderCart(cartData.items);
    } catch (error) {
      console.error("Error fetching updated cart:", error);
    }
  }

  function renderCart(cartItems) {
    const cartItemsContainer = document.getElementById('cart-items');
    cartItemsContainer.innerHTML = ''; // Clear current items
  
    if (cartItems.length === 0) {
      document.getElementById('empty-message').style.display = 'block';
    } else {
      document.getElementById('empty-message').style.display = 'none';
  
      cartItems.forEach(item => {
        const listItem = document.createElement('li');
        listItem.setAttribute('data-id', item.id);
        listItem.innerHTML = `${item.name} - $${item.price} <button class="cart-btn" data-id="${item.id}">Remove</button>`;
        cartItemsContainer.appendChild(listItem);
      });
      attachEventListeners();
    }
  }

  function attachEventListeners() {
    const removeBtns = document.querySelectorAll('.cart-btn');
    removeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const itemId = e.target.getAttribute('data-id');
        removeItemFromCart(itemId);
      });
    });
  }

  function removeItemFromCart(itemId) {
    console.log(removeItemFromCart, 'removeItemFromCart')
    cartItems = cartItems.filter(item => item.id !== itemId);
    renderCart(cartItems); // Re-render cart items after removing
  }

  console.log(cartBtns, 'cartBtns')
  if (cartBtns) {
    cartBtns.forEach((btn) => {
      let item = btn.getAttribute("data-item");
      item = JSON.parse(item);
      btn.addEventListener("click", async (e) => {
        if (!customerData) {
          showNotAllowedMessage();
        } else {
          console.log(item, 'click this item')
          e.preventDefault();
          const product = {
            product_id: item.product_id,
            product_handle: item.handle,
            proimage: item.image,
            protitle: item.title,
            vname: item.product_title,
            proprice: item.price,
            checked: true,
          };

          addItem(product);

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            });
  
            const result = await response.json();
  
            if (!response.ok) {
              console.error("Error removing item:", result);
            } else {
              console.log("Item removed from cart:", result);
              updateCartDisplay()
            }
          } catch (error) {
            console.error("Network error while removing item:", error);
          }
        }
      });
    });
  }

  function showNotAllowedMessage() {
    const existingAlert = document.getElementById("not-allowed-alert");
    if (existingAlert) return;

    const overlay = document.createElement("div");
    overlay.id = "alert-overlay";
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    overlay.style.zIndex = "9998";
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";

    const alertElement = document.createElement("div");
    alertElement.id = "not-allowed-alert";
    alertElement.style.position = "relative";
    alertElement.style.display = "flex";
    alertElement.style.flexDirection = "column";
    alertElement.style.gap = "10px";
    alertElement.style.backgroundColor = "#fff";
    alertElement.style.padding = "20px";
    alertElement.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
    alertElement.style.textAlign = "center";
    alertElement.style.maxWidth = "90%";
    alertElement.style.width = "500px";
    alertElement.style.height = "200px";
    alertElement.style.justifyContent = "center";
    alertElement.style.zIndex = "9999";
    alertElement.style.transition = "opacity 0.5s ease";
    alertElement.style.opacity = "0";

    const closeButton = document.createElement("span");
    closeButton.innerHTML = "&times;";
    closeButton.style.position = "absolute";
    closeButton.style.top = "10px";
    closeButton.style.right = "10px";
    closeButton.style.cursor = "pointer";
    closeButton.style.fontSize = "20px";
    closeButton.style.fontWeight = "bold";
    closeButton.style.color = "#333";
    
    closeButton.addEventListener("click", closeAlert);

    alertElement.innerHTML = `
      <p class="x-text-['Chivo'] x-text-[16px] x-text-black">You must be logged in to use the wishlist feature.</p>
      <div class="x-flex x-flex-col x-gap-[10px] x-items-center">
        <a href="/account/login" class="btn btn-1">Login</a>
        <a href="/account/register" class="btn btn-2">Sign up</a>
      </div>
    `;
  
    alertElement.appendChild(closeButton);
  
    document.body.appendChild(overlay);
    document.body.appendChild(alertElement);

    setTimeout(() => {
      alertElement.style.opacity = "1";
    }, 10);

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) closeAlert();
    });
  }

  function closeAlert() {
    const alert = document.getElementById("not-allowed-alert");
    const overlay = document.getElementById("alert-overlay");
    if (alert) alert.style.opacity = "0";
    if (overlay) overlay.remove();
  }

  function handleNotLoggedIn(loadingMessage) {
    if (loadingMessage) {
      loadingMessage.innerHTML = `
        <div class="x-flex x-flex-col x-justify-center x-items-center">
          <div class="x-flex x-flex-col md:x-flex-row x-gap-4 alert-btns x-max-w-[700px] x-w-full">
            <a style="background-color:#9A8C6F; width:100%; border-radius:0px" href="/account/login" class="btn x-text-[#F1F1F1] x-test-[14px] x-font-normal">Login</a>
            <a style="width:100%;; border-radius:0px" href="/account/register" class="btn !x-w-full btn-2 x-text-[#F1F1F1] x-test-[14px] x-font-normal">Sign up</a>
          </div>
        </div>
      `;
    }
  }

  const cartEle = document.querySelector('#cart-total');
console.log(cartEle, 'jas ')

  function fetchProductData() {
    console.log(wishlist, 'wishlist map')
    const productHandles = wishlist.map((item) => item.product_handle);
    console.log(wishlist)
    let fetchedProductsCount = 0;

    // Clear the previous wishlist before rendering the new one
    if (wishlistHandlesElement) {
      wishlistHandlesElement.innerHTML = "";
    }

    productHandles.forEach((handle) => {
      console.log(handle, 'her')
      fetch(`/products/${handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const priceHTML = `<div class="product-price">R ${(
            product.price / 100
          ).toFixed(2)}</div>`;

          if (wishlistHandlesElement) {
            wishlistHandlesElement.innerHTML += `
          <div class="wishlist-product x-items-center x-grid x-relative" data-handle="${product.handle}">
          <div style="top:20px; padding-right:20px;" class="remove-btn x-flex x-w-full x-justify-end x-cursor-pointer x-absolute md:x-hidden" data-id="${product.id}">
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none">
            <path d="M1 1L22.9996 22.9996" stroke="black" stroke-width="2.82837"/>
            <path d="M23 1L1.00041 22.9996" stroke="black" stroke-width="2.82837"/>
          </svg>
          </div>  
            <a href="/products/${product.handle}" class="product-info x-border-left-none md:x-border-left x-max-h-[135px] x-pointer-events-none">
              <img width="200" height="200" src="${product.images[0]}" class="wishlist-img x-object-contain x-mix-blend-multiply "/>
              <div class="product-title md:x-pr-[30px] x-flex x-flex-col x-w x-gap-[20px]"><p class="x-text-[16px] md:x-text-[20px]" style="color: #000;
              font-family: Chivo;
              font-style: normal;
              font-weight: 300;
              line-height: 140%;
              text-transform: uppercase;
              text-wrap: pretty;
              width: 128px;">${product.title}</p>
                <div class="product-price-container-sm x-text-[16px] md:x-text-[20px]">
                  ${priceHTML}
                </div>
                <div class="x-hidden md:x-flex">
                  ${priceHTML}
                </div>
                <button style="border-radius:0;" class="btn btn-1-alt add-to-cart-btn" js-quick-add data-handle="${product.handle}" data-id="${product.id}" data-variant-id="${product.variants[0].id}">Add to Cart</button>
              </div>
            </a>
            <div class="product-actions">
            <div class="remove-btn md:x-flex x-w-full x-justify-end x-cursor-pointer x-hidden" data-id="${product.id}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M1 1L22.9996 22.9996" stroke="black" stroke-width="2.82837"/>
              <path d="M23 1L1.00041 22.9996" stroke="black" stroke-width="2.82837"/>
            </svg>
            </div>          
            <button style="border-radius:0;" class="btn btn-1 add-to-cart-btn" js-quick-add data-handle="${product.handle}" data-id="${product.id}" data-variant-id="${product.variants[0].id}">Add to Cart</button>
            </div>
            </div>
            `;

            fetchedProductsCount++;

            if (fetchedProductsCount === wishlist.length) {
              loadingMessage.style.display = "none";
              wishlistHandlesElement.style.display = "grid";
            }

            const addToCartButtons =
              document.querySelectorAll(".add-to-cart-btn");
            addToCartButtons.forEach((button) => {
              button.addEventListener("click", function (e) {
                e.preventDefault();
                const productId = this.getAttribute("data-id");
                const productVariantId = this.getAttribute("data-variant-id");
                // Trigger the quick-add functionality using Liquid AJAX API
                fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: productVariantId,
                    quantity: 1,
                  }),
                })
                  .then((response) => response.json())
                  .then((data) => {
                    alertBanner.classList.remove("x-hidden");
                    alertBanner.classList.add("x-flex");

                    alertBanner.innerHTML = `
              Product has been successfully added to cart!
              `;

                    // Hide the alert banner after 3 seconds
                    setTimeout(() => {
                      alertBanner.classList.add("x-hidden");
                    }, 3000);

                    removeItem(productId, product);
                    fetch('https://za.truth.coffee/cart.js').then((data) => data.json()).then((data) => {

                      console.log(data, 'data')
                      const cartEle = document.querySelector('#cart-total');
                      console.log('then element', cartEle);
                      
  
                      cartEle.innerHTML = data.item_count
                    })
                    // Optionally refresh or update the cart UI
                  })
                  .catch((error) => {
                    console.error("Error adding product to cart:", error);
                  });
              });
            });

            const removeButtons = document.querySelectorAll(".remove-btn");
            removeButtons.forEach((button) => {
              button.addEventListener("click", function (e) {
                e.preventDefault();
                const productId = this.getAttribute("data-id");
                removeItem(productId, product);
              });
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    });
  }

  function renderWishlist(productData) {
    if (wishlist.length > 0) {
      wishlist.forEach((item) => {
        const product = productData.find((p) => p.product_id === item.product_id);
        if (product) {
          const productElement = document.createElement("div");
          productElement.innerHTML = `
            <div class="product">
              <img src="${product.image}" alt="${product.title}" />
              <div class="product-title">${product.title}</div>
              <div class="product-price">${product.price}</div>
              <button class="remove-wishlist-btn" data-id="${product.product_id}">Remove</button>
            </div>
          `;
          wishlistHandlesElement.appendChild(productElement);
          document.querySelector(`[data-id="${product.product_id}"]`).addEventListener('click', (e) => {
            const productId = e.target.getAttribute("data-id");
            removeItem(productId);
          });
        }
      });
    }
  }
});